import { useState } from 'react';

import { LUMO_APP_NAME } from '@proton/shared/lib/constants';
import lumoCatIcon from '@proton/styles/assets/img/lumo/lumo-cat-icon.svg';
import clsx from '@proton/utils/clsx';
import generateUID from '@proton/utils/generateUID';

import LogoBase, { type LogoProps } from './LogoBase';

const WORDMARK_WIDTH = 107;
const WORDMARK_HEIGHT = 26;

export const LumoCatMark = () => (
    <>
        <path
            fill="#4129A3"
            d="M16.291 20.3283C16.291 20.6328 16.0962 20.9066 15.8071 20.9999C13.6508 21.6971 11.6063 21.7884 10.6979 21.7884C9.54232 21.7884 7.58189 21.6787 5.59993 21.0737C5.30362 20.9835 5.10368 20.7077 5.10368 20.398V18.418H16.291V20.3293V20.3283Z"
        />
        <path
            fill="#FFAC2E"
            d="M10.6997 24.3037C9.85971 24.3037 9.17874 23.6227 9.17874 22.7827C9.17874 21.9427 9.85971 21.2617 10.6997 21.2617C11.5397 21.2617 12.2207 21.9427 12.2207 22.7827C12.2207 23.6227 11.5397 24.3037 10.6997 24.3037Z"
        />
        <path
            fill="#372580"
            d="M10.6992 22.0859C10.4378 22.0861 10.2256 22.2982 10.2256 22.5596C10.2256 22.7411 10.3295 22.8961 10.4795 22.9756V23.2988C10.4795 23.42 10.5781 23.5183 10.6992 23.5186C10.8205 23.5186 10.9189 23.4201 10.9189 23.2988V22.9766C11.0693 22.8972 11.1729 22.7414 11.1729 22.5596C11.1728 22.2981 10.9607 22.0859 10.6992 22.0859Z"
        />
        <path
            fill="#6D4AFF"
            d="M18.874 10.2819L13.5914 6.04091L16.8612 3.89661C17.5208 3.47106 18.3988 3.88729 18.4858 4.66694L18.873 10.2819H18.874Z"
        />
        <path
            fill="#6D4AFF"
            d="M2.33656 10.2819L7.61914 6.04091L4.34936 3.89661C3.68982 3.47106 2.8118 3.88729 2.72483 4.66694L2.33759 10.2819H2.33656Z"
        />
        <path
            fill="#4A2DC5"
            d="M4.77399 6.29927L5.86426 7.00023L4.08649 8.19508L4.30185 6.51877C4.33084 6.29409 4.58347 6.17709 4.77295 6.29927H4.77399Z"
        />
        <path
            fill="#4A2DC5"
            d="M16.4355 6.29927L15.3453 7.00023L17.123 8.19508L16.9077 6.51877C16.8787 6.29409 16.6261 6.17709 16.4366 6.29927H16.4355Z"
        />
        <path
            fill="#6D4AFF"
            d="M1.20314 14.1663C1.20314 18.4859 6.32934 20.0256 10.6055 20.0256C14.3639 20.0256 20.0078 18.4859 20.0078 14.1663C20.0078 9.84669 15.7979 5.48047 10.6055 5.48047C5.41302 5.48047 1.20314 9.84669 1.20314 14.1663Z"
        />
        <path
            stroke="white"
            strokeWidth="0.312088"
            strokeMiterlimit="10"
            strokeLinecap="round"
            d="M11.96 15.9961C11.5468 15.9961 11.2132 16.3309 11.2132 16.7429"
        />
        <path
            stroke="white"
            strokeWidth="0.312088"
            strokeMiterlimit="10"
            strokeLinecap="round"
            d="M10.4642 15.9961C10.8774 15.9961 11.2109 16.3309 11.2109 16.7429"
        />
        <path
            fill="white"
            d="M14.8272 10.812C16.6278 10.1649 17.9355 11.1962 18.4687 11.7408C18.6519 11.9282 18.7472 12.187 18.7255 12.449C18.6654 13.1924 18.3227 14.7641 16.5418 15.433C14.7371 16.0812 13.4418 15.0893 12.9169 14.5664C12.7378 14.3883 12.6456 14.1408 12.6612 13.8892C12.7088 13.1355 13.0246 11.4892 14.8272 10.812Z"
        />
        <path
            fill="#372480"
            d="M12.6463 13.8715C12.7643 13.1436 13.047 12.4634 13.5087 11.9478C14.4302 10.9341 15.9958 10.52 17.2755 11.0501C17.5955 11.1826 17.903 11.3617 18.1815 11.5843C18.4704 11.7945 18.7106 12.072 18.7437 12.4468C18.8162 12.0617 18.5987 11.69 18.3347 11.4208C18.0769 11.1433 17.7725 10.902 17.4288 10.7229C16.3871 10.1565 15.0618 10.2973 14.0782 10.9269C13.0863 11.5243 12.5106 12.7523 12.6463 13.8715Z"
        />
        <path
            fill="white"
            d="M7.49145 10.812C5.69089 10.1649 4.38319 11.1962 3.84996 11.7408C3.6667 11.9282 3.57144 12.187 3.59318 12.449C3.65324 13.1924 3.99595 14.7641 5.77683 15.433C7.58153 16.0812 8.8768 15.0893 9.40175 14.5664C9.58087 14.3883 9.67302 14.1408 9.65749 13.8892C9.60986 13.1355 9.29407 11.4892 7.49145 10.812Z"
        />
        <path
            fill="#372480"
            d="M9.67077 13.8715C9.8064 12.7533 9.23073 11.5243 8.23882 10.9269C7.25623 10.2973 5.92988 10.1565 4.88828 10.7229C4.54453 10.902 4.24012 11.1433 3.98231 11.4208C3.71828 11.6889 3.50085 12.0617 3.57333 12.4468C3.60646 12.072 3.84564 11.7956 4.13555 11.5843C4.41407 11.3628 4.72158 11.1826 5.04152 11.0501C6.32126 10.52 7.88678 10.9341 8.80828 11.9478C9.27007 12.4634 9.55273 13.1436 9.67077 13.8715Z"
        />
        <path
            fill="#4129A3"
            d="M7.03758 14.9469C6.56753 14.9469 6.18648 14.2173 6.18648 13.3172C6.18648 12.4171 6.56753 11.6875 7.03758 11.6875C7.50762 11.6875 7.88867 12.4171 7.88867 13.3172C7.88867 14.2173 7.50762 14.9469 7.03758 14.9469Z"
        />
        <path
            opacity="0.7"
            fill="white"
            d="M6.41256 12.5674C6.1987 12.5674 6.02533 12.3941 6.02533 12.1802C6.02533 11.9663 6.1987 11.793 6.41256 11.793C6.62643 11.793 6.7998 11.9663 6.7998 12.1802C6.7998 12.3941 6.62643 12.5674 6.41256 12.5674Z"
        />
        <path
            fill="#4129A3"
            d="M15.8872 14.9469C15.4171 14.9469 15.0361 14.2173 15.0361 13.3172C15.0361 12.4171 15.4171 11.6875 15.8872 11.6875C16.3572 11.6875 16.7383 12.4171 16.7383 13.3172C16.7383 14.2173 16.3572 14.9469 15.8872 14.9469Z"
        />
        <path
            opacity="0.7"
            fill="white"
            d="M15.2612 12.5674C15.0473 12.5674 14.874 12.3941 14.874 12.1802C14.874 11.9663 15.0473 11.793 15.2612 11.793C15.4751 11.793 15.6484 11.9663 15.6484 12.1802C15.6484 12.3941 15.4751 12.5674 15.2612 12.5674Z"
        />
    </>
);

const LumoWordmarkText = () => (
    <>
        <path
            fill="var(--logo-text-proton-color)"
            d="M37.1914 15.9961C37.1914 16.7062 37.3063 17.2659 37.5361 17.6738C37.7813 18.0666 38.1188 18.3465 38.5479 18.5127C38.9768 18.6788 39.4752 18.7617 40.042 18.7617C40.854 18.7617 41.5435 18.5804 42.1104 18.2178C42.6772 17.8552 43.1297 17.4097 43.4668 16.8809C43.7091 16.5069 43.8921 16.1426 44.0186 15.79V9.40039H46.5703V20.6885H44.0186V16.7461C44.0035 16.8033 43.9896 16.8637 43.9727 16.9258C43.8808 17.3187 43.7191 17.7495 43.4893 18.2178C43.2748 18.671 42.9838 19.1093 42.6162 19.5322C42.2638 19.9401 41.8194 20.2808 41.2832 20.5527C40.7468 20.8097 40.0952 20.9385 39.3291 20.9385C38.7774 20.9385 38.2174 20.8621 37.6504 20.7109C37.099 20.5749 36.5933 20.341 36.1338 20.0088C35.6894 19.6764 35.3295 19.2226 35.0537 18.6484C34.7779 18.0743 34.6397 17.3489 34.6396 16.4727V9.40039H37.1914V15.9961ZM77.5283 9.14941C78.8004 9.14942 79.9346 9.38309 80.9307 9.85156C81.9266 10.32 82.7084 11.0001 83.2754 11.8916C83.8576 12.768 84.1484 13.8264 84.1484 15.0654C84.1484 16.3195 83.8576 17.3853 83.2754 18.2617C82.7084 19.138 81.9267 19.8036 80.9307 20.2568C79.9346 20.7102 78.8003 20.9365 77.5283 20.9365C76.2566 20.9365 75.1149 20.7101 74.1035 20.2568C73.0921 19.8036 72.2943 19.1381 71.7119 18.2617C71.1299 17.3853 70.8389 16.3194 70.8389 15.0654C70.8389 13.8264 71.1298 12.768 71.7119 11.8916C72.2943 11.0001 73.0921 10.32 74.1035 9.85156C75.1149 9.38323 76.2566 9.14941 77.5283 9.14941ZM28.8096 15.7617C28.8096 16.4719 28.9254 17.0315 29.1553 17.4395C29.2665 17.6176 29.3968 17.7728 29.5459 17.9043C29.9059 18.2219 30.4144 18.2783 30.8975 18.2783H33.9209V20.7041C33.3689 20.7041 29.8367 20.6287 29.2695 20.4775C28.718 20.3416 28.2125 20.1067 27.7529 19.7744C27.3086 19.442 26.9477 18.9882 26.6719 18.4141C26.3962 17.8399 26.2588 17.1145 26.2588 16.2383V4.83594H28.8096V15.7617ZM64.9746 9.14941C65.6487 9.14944 66.2619 9.23959 66.8135 9.4209C67.365 9.60221 67.84 9.88211 68.2383 10.2598C68.652 10.6224 68.9742 11.0761 69.2041 11.6201C69.4339 12.1641 69.5488 12.8066 69.5488 13.5469V20.6875H66.9746V14.0459C66.9746 13.1242 66.7439 12.4441 66.2842 12.0059C65.8399 11.5525 65.1353 11.3252 64.1699 11.3252C63.4343 11.3252 62.7596 11.4844 62.1465 11.8018C61.5491 12.104 61.0587 12.5044 60.6758 13.0029C60.57 13.142 60.4769 13.2857 60.3965 13.4336C60.3971 13.471 60.3994 13.509 60.3994 13.5469V20.6875H57.8477V14.0459C57.8477 13.1242 57.6178 12.4441 57.1582 12.0059C56.7138 11.5526 56.0093 11.3252 55.0439 11.3252C54.3084 11.3252 53.6335 11.4844 53.0205 11.8018C52.423 12.104 51.9329 12.5044 51.5498 13.0029C51.311 13.3043 51.1343 13.6263 51.0205 13.9688V20.6875H48.4688V9.39844H51.0205V12.6514C51.1081 12.3593 51.2222 12.0756 51.3652 11.8018C51.6257 11.288 51.9714 10.8343 52.4004 10.4414C52.8294 10.0335 53.3348 9.71591 53.917 9.48926C54.4994 9.26258 55.1437 9.14941 55.8486 9.14941C56.5073 9.14945 57.1125 9.23966 57.6641 9.4209C58.2309 9.60221 58.7138 9.88209 59.1123 10.2598C59.526 10.6224 59.8402 11.0762 60.0547 11.6201C60.1433 11.83 60.2141 12.0549 60.2686 12.2939C60.3392 12.1197 60.4212 11.9474 60.5146 11.7783C60.7904 11.2647 61.1433 10.8117 61.5723 10.4189C62.0013 10.026 62.4994 9.71594 63.0664 9.48926C63.6487 9.26261 64.285 9.14941 64.9746 9.14941ZM77.5283 11.1895C76.7775 11.1895 76.0954 11.3403 75.4824 11.6426C74.8694 11.9448 74.3713 12.3837 73.9883 12.958C73.6207 13.5321 73.4366 14.2346 73.4365 15.0654C73.4366 15.8813 73.6205 16.5772 73.9883 17.1514C74.356 17.7253 74.8463 18.1563 75.459 18.4434C76.0873 18.7305 76.7775 18.874 77.5283 18.874C78.2637 18.874 78.938 18.7303 79.5508 18.4434C80.1636 18.1563 80.6466 17.7253 80.999 17.1514C81.3668 16.5772 81.5507 15.8813 81.5508 15.0654C81.5507 14.2495 81.3667 13.5546 80.999 12.9805C80.6466 12.4063 80.1638 11.9673 79.5508 11.665C78.9532 11.3479 78.2791 11.1895 77.5283 11.1895Z"
        />
        <path
            fill="var(--logo-text-product-color)"
            d="M90.3449 17.4577V15.3965H98.1583V17.4577H90.3449ZM87.3086 20.6876L93.0371 6.91797H95.5066L101.276 20.6876H98.7858L93.7658 8.25668H94.7779L89.7781 20.6876H87.3086Z"
        />
        <path fill="var(--logo-text-product-color)" d="M103.007 6.91797H105.315V20.6876H103.007V6.91797Z" />
    </>
);

const LumoLogo = ({ variant = 'with-wordmark', hasTitle = true, className, size, ...rest }: LogoProps) => {
    const [uid] = useState(generateUID('logo'));

    if (variant === 'glyph-only') {
        return (
            <img
                src={lumoCatIcon}
                alt={hasTitle ? LUMO_APP_NAME : ''}
                aria-hidden={!hasTitle}
                className={clsx('logo', 'glyph-only', size && `icon-size-${size}`, className)}
            />
        );
    }

    return (
        <LogoBase
            uid={uid}
            logoWidth={WORDMARK_WIDTH}
            logoHeight={WORDMARK_HEIGHT}
            viewBox={`0 0 ${WORDMARK_WIDTH} ${WORDMARK_HEIGHT}`}
            title={hasTitle ? LUMO_APP_NAME : undefined}
            variant={variant}
            className={className}
            {...rest}
        >
            <LumoCatMark />
            <LumoWordmarkText />
        </LogoBase>
    );
};

export default LumoLogo;
